import { render } from "./Audience.vue?vue&type=template&id=79aebb61&scoped=true"
import script from "./Audience.vue?vue&type=script&lang=js"
export * from "./Audience.vue?vue&type=script&lang=js"

import "./Audience.vue?vue&type=style&index=0&id=79aebb61&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79aebb61"]])

export default __exports__